module.exports = __webpack_public_path__ + "static/media/img_background_football.0d5bc838.jpg";